import apiClient from 'helpers/api-client'
import { isEmpty } from 'lodash'
import { StateCreator } from 'zustand'
import {
  IBankAccountVerify,
  IPayloadBankAccountVerify,
} from './interface'
import { clientHeadersMapper } from 'helpers/client-headers-mapper'

export const createBankAccountVerifySlice: StateCreator<
  IBankAccountVerify
> = (set, get) => ({
  // state
  uploadIDCardProgress: 0,
  uploadIDCardRequest: null,
  uploadIDCardProgressDone: false,
  uploadIDCardError: false,

  uploadNPWPProgress: 0,
  uploadNPWPRequest: null,
  uploadNPWPProgressDone: false,
  uploadNPWPError: false,

  createBankAccountVerifyForm: {},
  isLoadingBankAccountVerify: false,
  bankAccountVerify: {
    bank_account_status: '',
    account_no: '',
    account_name: '',
    bank: {
      bank_id: 0,
      bank_code: '',
      bank_name: '',
    },
  },
  isSuccessVerify: false,
  isErrorVerify: false,
  responseMsg: '',

  // actions
  setBankAccountVerifyForm: async (payload: any) => {
    if (isEmpty(payload))
      set({
        createBankAccountVerifyForm: {},
      })
    else
      set({
        createBankAccountVerifyForm: {
          ...get().createBankAccountVerifyForm,
          ...payload,
        },
      })
  },
  requestBankAccountVerify: async (
    payload: IPayloadBankAccountVerify,
  ) => {
    try {
      set({
        isLoadingBankAccountVerify: true,
      })
      const res = await apiClient.post(
        '/user/hub/v1/bank-account',
        payload,
      )
      if (res?.data?.code === 'SUCCESS') {
        set({
          isSuccessVerify: true,
          bankAccountVerify: res?.data?.data,
        })
      }
      set({
        isLoadingBankAccountVerify: false,
        isErrorVerify: false,
        responseMsg: '',
      })
    } catch (error) {
      set({
        isLoadingBankAccountVerify: false,
        isSuccessVerify: false,
        isErrorVerify: true,
        responseMsg: error.message,
      }),
        console.error(error)
    }
  },
  uploadPhoto: async (payload: { type: string; file: File }) => {
    try {
      if (payload.type === 'isIdCard') {
        set(() => ({
          uploadIDCardProgress: 0,
          uploadIDCardProgressDone: false,
          uploadIDCardError: false,
        }))
      } else {
        set(() => ({
          uploadNPWPProgress: 0,
          uploadNPWPProgressDone: false,
          uploadNPWPError: false,
        }))
      }

      const fileName = payload?.file?.name
      const res = await apiClient.post(
        '/content/hub/v1/presigned-url',
        {
          target:
            payload.type === 'isIdCard'
              ? 'post_kyc_id_card'
              : 'post_kyc_npwp',
          ext:
            '.' + fileName.substring(fileName.lastIndexOf('.') + 1),
        },
      )
      const urlBlob = URL.createObjectURL(payload.file)
      const blob = await (await fetch(urlBlob)).blob()
      var oReq = new XMLHttpRequest()
      if (payload.type === 'isIdCard') {
        set(() => ({
          uploadIDCardRequest: oReq,
        }))
      } else {
        set({
          uploadNPWPRequest: oReq,
        })
      }

      oReq.open('PUT', res.data.data.presign_url, true)
      if (res?.data?.data?.presign_url_headers) {
        const mappedHeaders = clientHeadersMapper(
          res?.data?.data?.presign_url_headers,
        )
        for (const key in mappedHeaders) {
          oReq.setRequestHeader(key, mappedHeaders[key])
        }
      } else {
        oReq.setRequestHeader('Content-Type', payload.file.type)
        oReq.setRequestHeader('Cache-Control', 'max-age=31536000')
      }
      oReq.upload.addEventListener('progress', function (event) {
        if (event.lengthComputable) {
          const progress = (event.loaded / event.total) * 100
          if (payload.type === 'isIdCard') {
            set(() => ({
              uploadIDCardProgress: progress | 0,
            }))
          } else {
            set({
              uploadNPWPProgress: progress | 0,
            })
          }
        }
      })
      oReq.upload.addEventListener('load', function () {
        if (payload.type === 'isIdCard') {
          set(() => ({
            uploadIDCardProgressDone: true,
          }))
        } else {
          set({
            uploadNPWPProgressDone: true,
          })
        }
      })
      oReq.upload.addEventListener('error', () => {
        if (payload.type === 'isIdCard') {
          set(() => ({
            uploadIDCardError: true,
          }))
        } else {
          set({
            uploadNPWPError: true,
          })
        }
      })
      oReq.send(blob)
      return res.data.data.file_name
    } catch (error) {
      throw error
    }
  },
  abortUploadPhoto: (type = 'isIdCard') => {
    if (type === 'isIdCard') {
      if (get().uploadIDCardRequest)
        get().uploadIDCardRequest?.abort()
    } else {
      if (get().uploadNPWPRequest) get().uploadNPWPRequest?.abort()
    }
  },
  resetStatusVerify: () => {
    set({
      isSuccessVerify: false,
      createBankAccountVerifyForm: {},
    })
  },
})
